import React, { FC, PropsWithChildren } from "react";

import Heading from "components/heading";
import HeroSection from "components/hero-section";

type FeatureTableProps = PropsWithChildren<{ title: string }>;

const FeatureTable: FC<FeatureTableProps> = ({ title, children }) => (
  <div className="bg-gray-100">
    <HeroSection>
      <div className="w-full p-4">
        <div className="flex gap-4 w-full items-center justify-between bg-gradient-to-r from-navy to-primary px-4 py-2 text-left text-gray-100 rounded-b-none rounded-t-lg">
          <Heading tag="h6" fontWeight="regular">
            {title}
          </Heading>
        </div>
        <div className="flex-grow">{children}</div>
      </div>
    </HeroSection>
  </div>
);

export default FeatureTable;
